import { CommonModule, NgFor, NgIf, NgSwitch } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Referrals, ReferralsProgram } from '@app-shared/interfaces/settings/referral-program';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faQuestion, faCopy, faRotate } from '@fortawesome/free-solid-svg-icons';
import { AlertService } from '@main/alert.service';
import { FormatDateTimePipe } from '@main/format-date-time.pipe';
import { SettingService } from '@main/setting.service';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-settings-subscription-referral-program',
  imports: [CommonModule, FontAwesomeModule, NgbPopover, NgIf, NgFor, NgSwitch],
  templateUrl: './settings-subscription-referral-program.component.html',
  styleUrl: './settings-subscription-referral-program.component.css'
})
export class SettingsSubscriptionReferralProgramComponent implements OnInit {

  // Properties
  referralLink: string = `${environment.referralCodeUrl}?referralCode=`;
  referralCode: string = '';
  organizationReferralLists: Referrals[] = [];

  // Font Awesome Properties
  faQuestion = faQuestion;
  faCopy = faCopy;
  faRotate = faRotate;

  constructor(
    private alertService: AlertService,
    private settingService: SettingService) { }

  ngOnInit(): void {
    this.getOrganizationReferralLists();
  }

  // Get Organization ReferralLists
  getOrganizationReferralLists() {
    this.settingService.getReferralPrograms().subscribe({
      next: (response: ReferralsProgram) => {
        this.organizationReferralLists = response.referrals;
        this.referralCode = response?.referralProgram?.code;
      },
      error: (error) => {
        this.alertService.showErrorAlert(error);
      }
    });
  }

  // Copy Referral Link
  async copyReferralLink(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.referralLink.concat(this.referralCode));
      this.alertService.showSuccessAlert('Referral Link Copied to Clipboard');
    } catch (error) {
      this.alertService.showErrorAlert('Unable to Copy Referral Link');
    }
  }

  // Generate Referral Code
  generateReferralCode(): void {
    this.settingService.generateReferralProgramCode().subscribe(() => {
      this.alertService.showSuccessAlert('Referral Code Generated Successfully');
      this.getOrganizationReferralLists();
    });
  }
}
